import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { shouldAutoplay } from '../utils/functions';

export default function initAnimations() {
  if (!shouldAutoplay()) {
    const elements = document.querySelectorAll('[data-gsap]');
    elements.forEach((element) => {
      element.style.opacity = 1;
      element.style.transform = 'none';
        element.style.transition = 'none';
    });
    return
  }

  gsap.registerPlugin(ScrollTrigger);

  const elements = document.querySelectorAll('[data-gsap]');

  if (elements.length == 0) return;

    elements.forEach((element) => {
      let delay = element.getAttribute('data-gsap-delay');

      const isMainNav = element.classList.contains('overlay-animation');

      const createTrigger = (extraDelay = false) => {
        if (element.hasAttribute('data-gsap-type')) {
          const type = element.getAttribute('data-gsap-type');
          if (type === 'stagger') {
            const items = element.querySelectorAll('[data-gsap-item]');
            gsap.set(items, { opacity: 0, y: 30 });
            gsap.set(element, { opacity: 1, transform: 'none' });

            ScrollTrigger.create({
              trigger: element,
              start: "top bottom-=100",
              end: "bottom top+=100",
              onEnter: () => {
                gsap.to(items, {
                  opacity: 1,
                  y: 0,
                  duration: 0.8,
                  ease: "power4.inOut",
                  delay: extraDelay ? 0.6 : 0,
                  stagger: {
                    each: 0.1,
                    from: "start",
                  },
                });
              },
            });
          }
          else if (type === "zoom") {
            gsap.set(element, {
              opacity: 0,
              scale: 1.1,
              transform: 'none',
            });

            ScrollTrigger.create({
              trigger: element,
              start: `top bottom-=100`,
              end: `bottom top+=100`,
              onToggle: (self) => {
                if (self.isActive) {
                  gsap.to(element, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.8,
                    ease: "power4.inOut",
                    delay: delay ? delay : 0,
                  });
                }
              },
            });
          }
        } else {
          ScrollTrigger.create({
            trigger: element,
            start: `top bottom-=100`,
            end: `bottom top+=100`,
            onToggle: (self) => {
              if (self.isActive) {
                gsap.to(element, {
                  opacity: 1,
                  y: 0,
                  duration: 0.8,
                  ease: "power4.inOut",
                  delay: delay ? delay : 0,
                });
              }
            },
          });
        }
      };

      // Specifieke handling voor overlay-main-nav
      if (isMainNav) {
        const observer = new MutationObserver(() => {
          if (document.body.classList.contains('nav-active')) {
            createTrigger(true); // Trigger pas aanmaken als nav actief is
          }
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      } else {
        createTrigger(); // Normale elementen meteen triggeren
      }
    });

}